module.exports = __webpack_public_path__ + "static/img/webDav.9d1171f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/webDav.svg
// module id = 0KXw
// module chunks = 2